// extracted by mini-css-extract-plugin
export default {"logout-btn":"styles_logout-btn__WoYMl"};